import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

/**
 * Access-control configs for the bulk account-management surfaces (requirements §12).
 *
 * NOTE on OR semantics: within a single config object, `permissions: [A, B]` means the
 * user needs *all* of A and B (AND). To express OR, use an array of config objects —
 * the user matches if they satisfy *any* object. See the workspace CLAUDE.md.
 */

/** Bulk *user* operator gate (Bulk Users page, Sparse 5). */
export const bulkUserModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ManageUsersModify],
}

/** Bulk *role* operator gate (Bulk Roles page, Sparse 5). */
export const bulkRoleModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.RoleManagementModify],
}

/** Bulk *user* approver gate (AMS approvals, Sparse 6). */
export const bulkUserApproveAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ManageUsersBulkUpsertApprove],
}

/** Bulk *role* approver gate (AMS approvals, Sparse 6). */
export const bulkRoleApproveAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.RoleManagementBulkUpsertApprove],
}

/**
 * Domain-level admin gate: a user who can modify users *or* roles may reach the
 * bulk domain (the individual pages re-gate themselves per kind). Array form ⇒ OR.
 */
export const accountManagementBulkAdminAccessControl: DomainAccessControlConfig = [
  bulkUserModifyAccessControl,
  bulkRoleModifyAccessControl,
]

/**
 * Approvals route gate: modify *or* approve, on either kind. Approvers who hold only an
 * approve permission (no modify) must still reach the pending-approval queue and the
 * `?requestId=` deep link they receive from notifications. `BulkApprovalsPage` re-gates
 * per kind internally. Array form ⇒ OR.
 */
export const accountManagementBulkApprovalsAccessControl: DomainAccessControlConfig = [
  bulkUserModifyAccessControl,
  bulkRoleModifyAccessControl,
  bulkUserApproveAccessControl,
  bulkRoleApproveAccessControl,
]
